// src/features/landing/presentation/components/CompanyQASection.jsx
import React from "react";

export function CompanyQASection() {
    return (
        <section className="company-qa-section">
            <div className="qa-container">
                {/* Q 섹션 */}
                <div className="question-section">
                    <div className="q-icon-wrapper">
                        <div className="q-icon">Q</div>
                    </div>
                    <h2 className="question-text">
                        <span className="brand-name">라이징브로커즈</span>, 어떤 회사인가요?
                    </h2>
                </div>

                {/* A 섹션 */}
                <div className="answer-section">
                    <div className="a-icon-wrapper">
                        <div className="a-icon">A</div>
                    </div>
                    <div className="answer-content">
                        {/* 메인 답변 */}
                        <div className="main-answer">
                            <h3 className="service-title">보험업계 출신이 만든 GA 전문 헤드헌팅 플랫폼</h3>
                            <p className="company-name-text">
                                <span className="rising-text">Rising</span>{" "}
                                <span className="brokers-text">Brokers</span> 는
                            </p>
                            <p className="mission-statement">
                                <span className="highlight-red">
                                    GA 매니저·총무·스태프의 역량을 정량·정성적으로 검증하고,
                                </span>
                                <br />
                                <span className="highlight-red">
                                    보험사/GA별 조직 특성에 최적화된 인재를 연결합니다.
                                </span>
                            </p>
                        </div>

                        {/* 상세 설명 */}
                        <div className="detailed-answer">
                            <p className="detail-line">
                                기존 지인 소개 방식의 한계(적기 채용 어려움, 높은 비용, 검증 부재)를 해결하기 위해,
                            </p>
                            <p className="detail-line">
                                <span className="emphasis-navy">인바운드/아웃바운드</span> 다채널 후보자 발굴부터
                            </p>
                            <p className="detail-line">
                                <span className="emphasis-navy">체계적 역량 평가</span>,
                                <span className="emphasis-navy"> 문화 적합도 분석</span>을 거쳐
                            </p>
                            <p className="detail-line">
                                보험사와 전문 인력 모두가 만족하는 <span className="emphasis-navy">매칭</span>을 목표로 합니다.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .company-qa-section {
                    width: 100%;
                    min-height: 100vh;
                    background: linear-gradient(
                        to bottom,
                        #fafbfc 0%,
                        #f5f6f8 50%,
                        #f0f2f5 100%
                    );
                    padding: 80px 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .qa-container {
                    max-width: 1200px;
                    width: 100%;
                }

                /* Q 섹션 */
                .question-section {
                    display: flex;
                    align-items: center;
                    gap: 40px;
                    margin-bottom: 80px;
                }

                .q-icon-wrapper {
                    flex-shrink: 0;
                }

                .q-icon {
                    width: 100px;
                    height: 100px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 3.5rem;
                    font-weight: 700;
                    box-shadow: 0 10px 30px rgba(44, 62, 80, 0.3);
                }

                .question-text {
                    font-size: 2.5rem;
                    font-weight: 600;
                    color: #2c3e50;
                    margin: 0;
                    line-height: 1.3;
                }

                .brand-name {
                    color: #3b5998;
                    font-weight: 700;
                }

                /* A 섹션 */
                .answer-section {
                    display: flex;
                    gap: 40px;
                    align-items: flex-start;
                }

                .a-icon-wrapper {
                    flex-shrink: 0;
                }

                .a-icon {
                    width: 100px;
                    height: 100px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 4rem;
                    font-weight: 700;
                    box-shadow: 0 10px 40px rgba(255, 107, 53, 0.4);
                }

                .answer-content {
                    flex: 1;
                    padding-top: 10px;
                }

                /* 메인 답변 */
                .main-answer {
                    margin-bottom: 50px;
                    text-align: left;
                }

                .service-title {
                    font-size: 2rem;
                    color: #ff5722;
                    font-weight: 700;
                    margin: 0 0 20px 0;
                    line-height: 1.3;
                }

                .company-name-text {
                    font-size: 1.8rem;
                    margin: 0 0 20px 0;
                    font-weight: 600;
                }

                .rising-text {
                    color: #ff6b35;
                }

                .brokers-text {
                    color: #2c3e50;
                }

                .mission-statement {
                    font-size: 1.6rem;
                    margin: 0;
                    line-height: 1.6;
                    font-weight: 600;
                }

                .highlight-red {
                    color: #e63946;
                }

                /* 상세 설명 */
                .detailed-answer {
                    padding: 30px 0;
                    border-top: 2px solid rgba(44, 62, 80, 0.1);
                    text-align: left;
                }

                .detail-line {
                    font-size: 1.3rem;
                    color: #2c3e50;
                    margin: 0 0 15px 0;
                    line-height: 1.6;
                    font-weight: 500;
                }

                .emphasis-navy {
                    color: #1e3a8a;
                    font-weight: 700;
                }

                /* 반응형 */
                @media (max-width: 1024px) {
                    .company-qa-section {
                        padding: 60px 30px;
                    }

                    .question-text {
                        font-size: 2rem;
                    }

                    .service-title {
                        font-size: 1.6rem;
                    }

                    .company-name-text {
                        font-size: 1.5rem;
                    }

                    .mission-statement {
                        font-size: 1.3rem;
                    }

                    .detail-line {
                        font-size: 1.1rem;
                    }
                }

                @media (max-width: 768px) {
                    .company-qa-section {
                        padding: 50px 20px;
                    }

                    .question-section {
                        gap: 20px;
                        margin-bottom: 60px;
                    }

                    .q-icon {
                        width: 70px;
                        height: 70px;
                        font-size: 2.5rem;
                    }

                    .question-text {
                        font-size: 1.5rem;
                    }

                    .answer-section {
                        gap: 20px;
                    }

                    .a-icon {
                        width: 80px;
                        height: 80px;
                        font-size: 3rem;
                    }

                    .service-title {
                        font-size: 1.3rem;
                    }

                    .company-name-text {
                        font-size: 1.2rem;
                    }

                    .mission-statement {
                        font-size: 1.1rem;
                    }

                    .detail-line {
                        font-size: 1rem;
                    }
                }

                @media (max-width: 480px) {
                    .company-qa-section {
                        padding: 40px 15px;
                    }

                    .question-section {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 15px;
                    }

                    .q-icon {
                        width: 60px;
                        height: 60px;
                        font-size: 2rem;
                    }

                    .question-text {
                        font-size: 1.2rem;
                    }

                    .answer-section {
                        flex-direction: column;
                        gap: 20px;
                    }

                    .a-icon {
                        width: 70px;
                        height: 70px;
                        font-size: 2.5rem;
                    }

                    .service-title {
                        font-size: 1.1rem;
                    }

                    .company-name-text {
                        font-size: 1rem;
                    }

                    .mission-statement {
                        font-size: 0.95rem;
                    }

                    .detail-line {
                        font-size: 0.9rem;
                        margin-bottom: 12px;
                    }
                }
            `}</style>
        </section>
    );
}
